/* Countdown del hero (slideshow). Fecha introducida en hora de la tienda (data-tz). */
(function () {
  if (customElements.get('slide-countdown')) return;

  function tzOffsetMs(ts, tz) {
    const p = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: tz, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date(ts)).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - ts;
  }

  // "AAAA-MM-DD HH:MM" en la zona tz -> timestamp UTC (ms). null si el formato no es válido.
  function parseTarget(str, tz) {
    const m = /^\s*(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})\s*$/.exec(str || '');
    if (!m) return null;
    const wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    let ts = wall - tzOffsetMs(wall, tz);
    ts = wall - tzOffsetMs(ts, tz); // corrige cambios de horario
    return ts;
  }

  const pad = function (n) { return String(n).padStart(2, '0'); };

  class SlideCountdown extends HTMLElement {
    connectedCallback() {
      this.target = parseTarget(this.dataset.target, this.dataset.tz || 'Europe/Madrid');
      if (this.target === null) { this.hidden = true; return; }
      this.units = {
        d: this.querySelector('[data-unit="d"]'),
        h: this.querySelector('[data-unit="h"]'),
        m: this.querySelector('[data-unit="m"]'),
        s: this.querySelector('[data-unit="s"]')
      };
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const diff = this.target - Date.now();
      if (diff <= 0) {
        clearInterval(this.timer);
        const end = this.querySelector('[data-end-text]');
        if (end) {
          this.querySelector('[data-countdown-units]').hidden = true;
          end.hidden = false;
        } else {
          this.hidden = true;
        }
        return;
      }
      const s = Math.floor(diff / 1000);
      this.units.d.textContent = pad(Math.floor(s / 86400));
      this.units.h.textContent = pad(Math.floor((s % 86400) / 3600));
      this.units.m.textContent = pad(Math.floor((s % 3600) / 60));
      this.units.s.textContent = pad(s % 60);
      this.hidden = false;
    }
  }

  customElements.define('slide-countdown', SlideCountdown);
})();
